import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { DateRange } from 'react-day-picker';
import { isSameDay } from 'date-fns';
import { IAvailableBookingPeriod } from '@shared/integrations/taf-api/v2/models';

const useGetAvailableDates = (range: DateRange | undefined, data: IAvailableBookingPeriod[] | AxiosError<any, any> | undefined) => {
    const [selectedPeriod, setSelectedPeriod] = useState<IAvailableBookingPeriod | undefined>();
    const handleSelectedRangeChange = (range: DateRange | undefined) => {
        if (!range || !range.from || !data || data instanceof AxiosError) {
            setSelectedPeriod(undefined);
            return;
        }
        const selectedStartDate = range.from;
        const period = data.find((x) => {
            if (x.startDate === undefined || x.startDate === null) return false;
            const startDate = new Date(x.startDate);
            return isSameDay(startDate, selectedStartDate);
        });

        setSelectedPeriod(period);
    };

    useEffect(() => {
        handleSelectedRangeChange(range);
    }, [range]);

    return selectedPeriod;
};
export default useGetAvailableDates;
